var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grow" },
    [
      _vm.inputType === "switch"
        ? [
            _c("v-switch", {
              attrs: {
                label: _vm.label,
                hint: _vm.tooltip,
                "persistent-hint": "",
                dense: "",
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "slider"
        ? [
            _c("v-slider", {
              attrs: {
                label: _vm.label + ": 1e" + _vm.computedValue,
                hint: _vm.tooltip,
                max: _vm.max,
                min: _vm.min,
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "dual-constant-profile"
        ? [
            _c("InputDualParam", {
              attrs: {
                label: _vm.label,
                "auto-allocation": _vm.autoAllocation,
                "auto-allocated": _vm.autoAllocated,
                tooltip: _vm.tooltip,
              },
              on: {
                "update:autoAllocated": function ($event) {
                  _vm.autoAllocated = $event
                },
                "update:auto-allocated": function ($event) {
                  _vm.autoAllocated = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "constant-switch",
                  fn: function () {
                    return [
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: { dense: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c(
                                  "p",
                                  { staticClass: "my-auto text-caption" },
                                  [_vm._v("Constant Values")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.constantSwitch,
                          callback: function ($$v) {
                            _vm.constantSwitch = $$v
                          },
                          expression: "constantSwitch",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "pt-8 pr-8 max-width-600" },
                        [
                          _c("InputServiceParam", {
                            attrs: {
                              "input-type": _vm.constantSwitch
                                ? "inputYearly"
                                : "inputYearlyProfile",
                              num_years: _vm.num_years,
                              suffix: _vm.suffix,
                              year_start: _vm.year_start,
                              "multi-year-upload": true,
                              "spread-values": true,
                              "fill-value": _vm.fillValue,
                              "profile-type": _vm.profileType,
                              "hide-label": "",
                            },
                            model: {
                              value: _vm.computedValue,
                              callback: function ($$v) {
                                _vm.computedValue = $$v
                              },
                              expression: "computedValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        : _vm.inputType === "profile"
        ? [_c("InputProfile", { attrs: { label: _vm.label } })]
        : _vm.inputType === "select"
        ? [
            _c("v-select", {
              attrs: { label: _vm.label, hint: _vm.tooltip, items: _vm.items },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "inputYearly"
        ? [
            _c("InputYearlyProfile", {
              attrs: {
                label: _vm.label,
                num_years: _vm.num_years,
                year_start: _vm.year_start,
                fill: "",
                suffix: _vm.suffix,
                "fill-value": _vm.fillValue,
                "object-value": "",
                "items-type": "constant",
                "spread-values": "",
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "inputYearlyProfile"
        ? [
            _c("InputYearlyProfile", {
              attrs: {
                label: _vm.label,
                suffix: _vm.suffix,
                hint: _vm.tooltip,
                num_years: _vm.num_years,
                "profile-type": _vm.profileType,
                "multi-year-upload": true,
                "hide-label": _vm.hideLabel,
                "items-type": "profile",
                "object-value": "",
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "numberTextField"
        ? [
            _c("InputTextField", {
              attrs: {
                label: _vm.label,
                hint: _vm.tooltip,
                suffix: _vm.suffix,
                type: "number",
                nullable: _vm.nullable,
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm.inputType === "inputPeakHours"
        ? [
            _c("InputServicePeakHours", {
              attrs: {
                label: _vm.label,
                tooltip: _vm.tooltip,
                suffix: _vm.suffix,
                year_start: _vm.year_start,
                num_years: _vm.num_years,
              },
              model: {
                value: _vm.computedValue,
                callback: function ($$v) {
                  _vm.computedValue = $$v
                },
                expression: "computedValue",
              },
            }),
          ]
        : _vm._e(),
      _vm.inputType === "custom" ? [_vm._t("custom")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }